import React, { lazy, Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { withStyles } from '@material-ui/core/styles';
import { HashRouter, Route } from 'react-router-dom';

import LoadingScreen from './LoadingScreen';
import PageLoadError from './PageLoadError';

// 画面ごとに別のチャンクに分け、開いたときに初めて読み込む。
// ログイン画面だけを開く人や、ほかの画面を開かない人に、すべての画面のコードを読み込ませないため。
const Dashboard = lazy(() => import('./Dashboard'));

const APIKeys = lazy(() => import('./Maps/APIKeys'));
const APIKey = lazy(() => import('./Maps/APIKey'));

const General = lazy(() => import('./Team/general'));
const Members = lazy(() => import('./Team/members'));
const Billing = lazy(() => import('./Team/Billing'));

const User = lazy(() => import('./User/User'));

const styles = () => ({});

function Router() {
  return (
    <HashRouter>
      {/* 読み込み中や読み込みに失敗したときの表示は本文の領域だけに出し、ヘッダーやサイドバーは残す。
          失敗は Sentry にも送る。ほかの画面に移ったらエラーの表示を消すよう、パスごとに作り直す */}
      <Route render={({ location }) => (
        <ErrorBoundary key={location.pathname} fallback={<PageLoadError />}>
          <Suspense fallback={<LoadingScreen minHeight="320px" />}>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/api-keys" component={APIKeys} />
            <Route exact path="/api-keys/:id" component={APIKey} />

            <Route exact path="/team/general" component={General} />
            <Route exact path="/team/members" component={Members} />
            <Route exact path="/team/billing" component={Billing} />

            <Route exact path="/user" component={User} />
          </Suspense>
        </ErrorBoundary>
      )} />
    </HashRouter>
  );
}

export default withStyles(styles)(Router);
